// SSR stub for @iconify/react — renders a span placeholder
export function Icon({ icon, className, width, height }: any) {
  return <span className={className} data-icon={icon} style={{ width, height, display: 'inline-block' }} />
}

export default Icon
